(() => {
  
  $(".sel-wrapper input").on("change", function () {
    $("#currentSelection").attr("data-variant", $(this).val());
    $("#currentSelection").attr("data-price", $(this).attr("data-price"));
    $("#currentSelection").attr("data-compare", $(this).attr("data-compare"));
    $(".product-single__thumbnails-items").removeClass("main").addClass("hide");
    $(`.product-single__thumbnails-items.${$(this).attr("data-handle")}`)
      .addClass("main")
      .removeClass("hide");
    $(
      `.product-single__thumbnails-items.${$(this).attr("data-handle")} a`
    ).addClass("active-thumb");
    $(".subtitle[data-variant_title]").html($(this).attr("data-variant_title") || "");

    $(".sel-wrapper input").prop("checked", false);
    $(this).prop("checked", true);

    const url = new URL(window.location.href);
    url.searchParams.set("variant", $(this).val());
    window.history.replaceState(null, "", url.toString());

    updateLinks();
    updatePrice();
    updateInstallment();
    updateThumbnail();
  });

  $(".sel-wrapper input:checked").trigger("change");
})();
